
import { useAuthStore } from "@/stores/authStore";
import { Alert, AlertDescription } from "@/components/ui/alert";
import { Link, useLocation } from "react-router-dom";
import { useProfile } from "@/hooks/useProfile";
import { Separator } from "@/components/ui/separator";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/components/ui/breadcrumb";
import { SidebarInset, SidebarTrigger } from "@/components/ui/sidebar";
import { PortfolioList } from "@/components/portfolio/PortfolioList";
import { DashboardHero } from "@/components/dashboard/DashboardHero";
import { PageContainer } from "@/components/ui/PageContainer";

const Dashboard = () => {
  const { user } = useAuthStore();
  const { profile } = useProfile(user);
  const location = useLocation();
  const isPortfoliosPage = location.pathname === '/portfolios';

  return (
    <div className="flex-1">
      <SidebarInset>
        <header className="flex h-14 shrink-0 items-center gap-2 border-b px-4 sticky top-0 bg-background z-10">
          <SidebarTrigger className="-ml-2" />
          <Separator orientation="vertical" className="h-6" />
          <Breadcrumb>
            <BreadcrumbList>
              <BreadcrumbItem>
                {isPortfoliosPage ? (
                  <BreadcrumbLink asChild>
                    <Link to="/">Dashboard</Link>
                  </BreadcrumbLink>
                ) : (
                  <BreadcrumbPage>Dashboard</BreadcrumbPage>
                )}
              </BreadcrumbItem>
              {isPortfoliosPage && (
                <>
                  <BreadcrumbSeparator />
                  <BreadcrumbItem>
                    <BreadcrumbPage>Portfolios</BreadcrumbPage>
                  </BreadcrumbItem>
                </>
              )}
            </BreadcrumbList>
          </Breadcrumb>
        </header>

        <main className="flex-1">
          {profile && !profile.is_active && (
            <Alert variant="destructive" className="m-4">
              <AlertDescription>
                Your account is currently deactivated. Visit your{" "}
                <Link to="/settings" className="underline font-medium hover:text-destructive">
                  Settings
                </Link>{" "}
                to reactivate your account.
              </AlertDescription>
            </Alert>
          )}

          {isPortfoliosPage ? (
            <PortfolioList />
          ) : (
            <PageContainer maxWidthClassName="max-w-[960px]">
              {/* Standardized page header */}
              <div className="flex flex-col mb-2">
                <div className="flex justify-between items-start">
                  <div>
                    <h1 className="text-2xl sm:text-3xl font-bold">Workspace</h1>
                    <p className="text-sm text-muted-foreground mt-1">
                      One place to see, plan and build wealth
                    </p>
                  </div>
                </div>
              </div>

              {/* Workspace container (Dashboard Hero) */}
              <DashboardHero />
            </PageContainer>
          )}
        </main>
      </SidebarInset>
    </div>
  );
}

export default Dashboard;
